export default __webpack_public_path__ + "static/comp1-79aada660bdbd8eba83bad2232a42702.png";